import { colors } from '../foundation';

type Props = {
  color: (typeof colors.monochrome)['6'] | (typeof colors.monochrome.inverse)['6'];
};

const More = ({ color }: Props) => {
  return (
    <div>
      <svg width="18" height="4" viewBox="0 0 18 4" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M3.5 2C3.5 2.82812 2.82812 3.5 2 3.5C1.17188 3.5 0.5 2.82812 0.5 2C0.5 1.17188 1.17188 0.5 2 0.5C2.82812 0.5 3.5 1.17188 3.5 2Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M10.5 2C10.5 2.82812 9.82812 3.5 9 3.5C8.17188 3.5 7.5 2.82812 7.5 2C7.5 1.17188 8.17188 0.5 9 0.5C9.82812 0.5 10.5 1.17188 10.5 2Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M17.5 2C17.5 2.82812 16.8281 3.5 16 3.5C15.1719 3.5 14.5 2.82812 14.5 2C14.5 1.17188 15.1719 0.5 16 0.5C16.8281 0.5 17.5 1.17188 17.5 2Z"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};
export default More;
